import FirstSlide from "./FirstSlide"
import SecondSlide from "./SecondSlide"

export default {
  FirstSlide,
  SecondSlide,
}
